import { render, staticRenderFns } from "./ApplicantMessageReservationToApplicant.vue?vue&type=template&id=47e2715e"
import script from "./ApplicantMessageReservationToApplicant.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageReservationToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports